export default function PDFVEditAIPrivacy() {
  return (
    <main className="min-h-screen bg-[#FBFAF6] text-[#26313B]">
      <section className="mx-auto max-w-3xl px-6 py-12">
        <header className="mb-8 text-center">
          <h1 className="text-4xl font-extrabold tracking-tight text-[#A8720E]">
            Privacy Policy – PDF Viewer &amp; Editor - AI
          </h1>
          <p className="mt-2 text-sm text-[#5B6B7C]">
            Effective date: <time dateTime="2026-03-21">March 21, 2026</time>
          </p>
          <p className="mt-1 text-xs text-[#8A93A2]">
            Published by <span className="font-semibold">Cosmovex</span>
          </p>
        </header>

        <div className="space-y-8 leading-relaxed text-[#3D4B59]">
          <p>
            <strong>Cosmovex</strong> built{" "}
            <strong>PDF Viewer &amp; Editor - AI</strong> as a free utility app
            to help users view, edit, merge, split, compress, and convert PDF
            documents with AI-powered tools. This page informs users about our
            policies regarding the collection, use, and disclosure of
            information when using our app.
          </p>

          <h2 className="text-2xl font-bold text-[#A8720E]">
            Information We Collect
          </h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>
              <strong>Camera &amp; Files:</strong> Used only when you choose to
              scan documents or import files. Images and PDFs are processed
              locally on your device and are not uploaded without your explicit
              consent.
            </li>
            <li>
              <strong>Analytics &amp; Crash Data:</strong> Basic app usage,
              performance, and crash reports are collected via Firebase to
              improve reliability and stability.
            </li>
            <li>
              <strong>Account Information:</strong> If you sign in using Google,
              we store your name, email, and profile photo within Firebase
              Authentication for syncing credits and personalization.
            </li>
            <li>
              <strong>AI Features:</strong> When using AI tools (summarize,
              translate, chat with PDF, resume builder), document content is
              processed via secure AI services. We do not store or retain
              AI-processed content on our servers.
            </li>
          </ul>

          <h2 className="text-2xl font-bold text-[#A8720E]">
            How We Use Information
          </h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>
              To provide PDF viewing, editing, merging, splitting, compression,
              and AI features.
            </li>
            <li>To improve performance, stability, and user experience.</li>
            <li>
              To process secure in-app purchases via Google Play Billing for
              credits and ad-free upgrades.
            </li>
            <li>
              To show contextual ads (if not upgraded to ad-free).
            </li>
          </ul>

          <h2 className="text-2xl font-bold text-[#A8720E]">
            Third-Party Services
          </h2>
          <p>
            PDF Viewer &amp; Editor - AI integrates with trusted third-party
            platforms:
          </p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Google Play Services</li>
            <li>Firebase Analytics &amp; Crashlytics</li>
            <li>Firebase Authentication</li>
            <li>Google AdMob</li>
            <li>Google Play Billing</li>
            <li>Google Gemini AI (for AI features)</li>
          </ul>

          <h2 className="text-2xl font-bold text-[#A8720E]">Data Retention</h2>
          <p>
            PDF files, scanned images, and AI-generated content remain on your
            device unless you explicitly share them. We do not retain or access
            user-generated content on our servers without your consent.
          </p>

          <h2 className="text-2xl font-bold text-[#A8720E]">Your Rights</h2>
          <p>
            You can request deletion of your account and associated data by
            visiting our{" "}
            <a
              href="/apps/pdfveditai/account-deletion"
              className="text-[#0F6BBF] underline"
            >
              Account Deletion
            </a>{" "}
            page or contacting{" "}
            <a
              href="mailto:cosmovex.apps@gmail.com"
              className="text-[#0F6BBF] underline"
            >
              cosmovex.apps@gmail.com
            </a>
            . Upon request, your data will be deleted within 7 working days.
          </p>

          <h2 className="text-2xl font-bold text-[#A8720E]">Security</h2>
          <p>
            We use Firebase Authentication and HTTPS encryption for secure data
            transmission. However, no system is 100% secure, and we cannot
            guarantee absolute data protection.
          </p>

          <h2 className="text-2xl font-bold text-[#A8720E]">
            Children's Privacy
          </h2>
          <p>
            PDF Viewer &amp; Editor - AI is not directed toward children under
            13 years old, and we do not knowingly collect personal data from
            minors.
          </p>

          <h2 className="text-2xl font-bold text-[#A8720E]">
            Changes to This Policy
          </h2>
          <p>
            We may update this Privacy Policy periodically. Updates will be
            posted on this page, and the effective date will be revised
            accordingly.
          </p>

          <h2 className="text-2xl font-bold text-[#A8720E]">Contact Us</h2>
          <p>
            For any privacy-related concerns or data deletion requests, please
            contact us at{" "}
            <a
              href="mailto:cosmovex.apps@gmail.com"
              className="text-[#0F6BBF] underline"
            >
              cosmovex.apps@gmail.com
            </a>
            .
          </p>
        </div>

        <footer className="mt-12 border-t border-[#E1DCCE] pt-4 text-center text-sm text-[#8A93A2]">
          © {new Date().getFullYear()} Cosmovex — All rights reserved.
        </footer>
      </section>
    </main>
  );
}
